import { IconDefinition } from "./types";

const chevronRight: IconDefinition = {
  iconName: "chevron-right",
  width: 16,
  height: 16,
  svgPathData: "M6 2l5 5.978L6 14",
  iconType: "stroke",
};

export { chevronRight };
